import { createSlice } from '@reduxjs/toolkit';
import { addNotificationCenter, getAllNotificationCenter, getNotificationCenterDetail, removeNotificationCenter } from 'services/actions/notificationCenterAction';

interface TemplateState {
    loading: boolean;
    notifyCenterInfo: any;
    error: any;
    success: boolean;
    loading1: boolean;
    addNotifyCenterInfo: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    rmvNotifyCenterInfo: any;
    error2: any;
    success2: boolean;
    loading3: boolean;
    success3: boolean;
    error3: any;
    notifyCenterDetailInfo: any;
}

const initialState: TemplateState = {
    loading: false,
    notifyCenterInfo: null,
    error: null,
    success: false,
    loading1: false,
    addNotifyCenterInfo: null,
    error1: null,
    success1: false,
    loading2: false,
    rmvNotifyCenterInfo: null,
    error2: null,
    success2: false,
    loading3: false,
    error3: null,
    success3: false,
    notifyCenterDetailInfo: null,
};

const notificationCenterSlice = createSlice({
    name: 'notificationCenterSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllNotificationCenter.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.notifyCenterInfo = null;
            })
            .addCase(getAllNotificationCenter.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.notifyCenterInfo = payload;
                state.success = true;
            })
            .addCase(getAllNotificationCenter.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(addNotificationCenter.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.addNotifyCenterInfo = null;
            })
            .addCase(addNotificationCenter.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.addNotifyCenterInfo = payload;
                state.success1 = true;
            })
            .addCase(addNotificationCenter.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(removeNotificationCenter.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.rmvNotifyCenterInfo = null;
            })
            .addCase(removeNotificationCenter.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.rmvNotifyCenterInfo = payload;
                state.success2 = true;
            })
            .addCase(removeNotificationCenter.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
            .addCase(getNotificationCenterDetail.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
                state.notifyCenterDetailInfo = null;
            })
            .addCase(getNotificationCenterDetail.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.notifyCenterDetailInfo = payload;
                state.success3 = true;
            })
            .addCase(getNotificationCenterDetail.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            });
    }
})

export default notificationCenterSlice.reducer;